<template>
  <eden-confirm-dialog
    title="Delete Activity"
    :button-text="'Delete'"
    :button-type="'danger'"
    :button-status="deleting"
    :show.sync="setShow"
    @confirm="deleteBadge"
  >
    <p>
      This action cannot be undone. Are you sure you want to delete this
      activity?
    </p>
  </eden-confirm-dialog>
</template>

<script>
import badges from "@/requests/discounts/badges";

export default {
  name: "BadgeDelete",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    badge: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    deleteBadge() {
      this.deleting = true;
      badges
        .delete(this.badge.id)
        .then((response) => {
          if (response.data.status) {
            this.$message.success(response.data.message);
            this.$emit("success");
            this.deleting = false;
            this.close();
          } else {
            this.deleting = false;
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {
          this.deleting = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    close() {
      this.setShow = false;
      this.deleting = false;
    },
  },
};
</script>
